import { render, staticRenderFns } from "./ImageAvatar.vue?vue&type=template&id=f1208108&scoped=true&"
import script from "./ImageAvatar.vue?vue&type=script&lang=js&"
export * from "./ImageAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ImageAvatar.vue?vue&type=style&index=0&id=f1208108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1208108",
  null
  
)

export default component.exports